import { useRouter } from "next/router";
import { useEffect } from "react";

import { RouteConfig } from "@/config/route.config";
import { StringUtils } from "@/util/string.utils";

export namespace RoutingUtils {
  export const getCompleteUrlFromPath = (
    path: string,
    { noTrailingSlash = false }: { noTrailingSlash?: boolean } = {},
  ) => {
    const url = new URL(path, window.location.origin).toString();
    if (noTrailingSlash) {
      return url.replace(/\/$/, "");
    }

    return url;
  };

  export const addQueryParams = (path: string, params: Record<string, string | number | boolean | undefined>) => {
    const sParams = new URLSearchParams();
    for (const [key, value] of Object.entries(params)) {
      if (value) {
        sParams.append(key, value.toString());
      }
    }

    return `${path}?${sParams.toString()}`;
  };

  export const useOnPageChange = (onPageChange: () => void) => {
    const router = useRouter();

    useEffect(() => {
      router.events.on("routeChangeComplete", onPageChange);
      return () => router.events.off("routeChangeComplete", onPageChange);
    }, [router.events, onPageChange]);
  };

  export const isPathInRoutes = (path: string, routeKeys: (keyof typeof RouteConfig)[]) => {
    const slicedPath = StringUtils.getLastCharacter(path) === "/" ? path.slice(0, -1) : path;
    const slicedRoutes = routeKeys
      .map((routeKey) => RouteConfig[routeKey])
      .filter((route): route is string => typeof route === "string")
      .map((route) => (StringUtils.getLastCharacter(route) === "/" ? route.slice(0, -1) : route));

    return slicedRoutes.includes(slicedPath);
  };

  export const getPageHeaderTitle = (path: string) => {
    switch (path) {
      case RouteConfig.Settings:
        return "Settings";
      case RouteConfig.Profile:
        return "Profile";
      case RouteConfig.Onboarding:
        return "Onboarding";
      case RouteConfig.BugReport:
        return "Bug report";
      case RouteConfig.DemoHome:
        return "Home";
      case RouteConfig.Home:
        return "Profile";
      case RouteConfig.Guest.Index:
        return "Guest profile";
      case RouteConfig.VipPortfolios:
        return "VIP Portfolio";
      case RouteConfig.MyWallet:
        return "My Wallet";
      case RouteConfig.Analytics:
        return "Analytics";
      case RouteConfig.Watchlist:
        return "Watchlist";
      case RouteConfig.Liveshow:
        return "One Lucky Dog";
      case RouteConfig.CeoVsEmployee:
        return "CEO vs Employee";
      case RouteConfig.MyRewards:
        return "My Rewards";
      default:
        return "Lossdog";
    }
  };
}
